  import React, { useContext } from "react";
  import { useState, useEffect } from "react";
  import "../../Tabels/Tabels.css";
  import { Link } from "react-router-dom";
  import { Context } from "../../../utils/context";
  import { library } from "@fortawesome/fontawesome-svg-core";
  import { fas } from "@fortawesome/free-solid-svg-icons";
  // *******************toster****************************
  import ModalSave from "../../common/ModelSave";
  import { CancelButton, SaveButton } from "../../common/Button";
  import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
  import { useForm } from "react-hook-form";
  import classNames from "classnames";
import { Website_Type } from "../../../utils/common";
  library.add(fas);

  const EditOffCanvance = (props) => {
    const id = props.show;
    const { postData, getData, IMG_URL, getDimension } = useContext(Context);
    const [showModal, setShowModal] = useState({
      code: 0,
      message: "",
    });

    const GetEditData = async () => {
      const response = await getData(`/masters/occasion/${id}`);
      reset(response?.data);
    };
    useEffect(() => {
      GetEditData();
    }, []);

    const {
      control,
      register,
      handleSubmit,
      formState: { errors },
      reset,
      getValues,
      watch,
    } = useForm();

    const imageFile = watch("image");

    const onSubmit = async (data) => {
      try {
        console.log(data);
        const finalData = new FormData();
          finalData.append("website_type_id", Website_Type?.Corporate);
        finalData.append("name", data?.name);
        finalData.append("sort_order", data?.sort_order);
        finalData.append("image", data.image[0]);
        const response = await postData(`/masters/occasion/${id}`, finalData);
        console.log(response);
        if (response?.success) {
          await setShowModal({ code: response.code, message: response.message });
        } else {
          await setShowModal({ code: response.code, message: response.message });
        }
        setTimeout(() => {
          setShowModal(0);
          props.handleClose();
        }, 1000);
      } catch (error) {
        console.log(error);
      }
    };

    const [imagePreview, setImagePreview] = useState(null); // State to store image preview

    const handleImageChange = (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result); // Set image preview
        };
        reader.readAsDataURL(file);
      }
    };
    const isReadOnly = getValues("sort_order") < 6;

  
    
    return (
      <>
        <Modal
          {...props}
          onHide={props.handleClose}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Edit occasion
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
              <Row className="justify-content-center">
                <Col md={6}>
                  <div className="main-form-section my-3">
                    <Row className="justify-content-center">
                      <Form.Group>
                        <Form.Label>occasion</Form.Label>

                        <InputGroup>
                          <Form.Control
                            type="text"
                            name="name"
                            placeholder="occasion"
                            className={classNames("", {
                              "is-invalid": errors?.name,
                            })}
                            readOnly={isReadOnly} 
                            {...register("name", {
                              required: "occasion Is Required",
                            })}
                          />
                        </InputGroup>
                        {isReadOnly && "The top five occasion names cannot be edited because they are shown in the popular links section."}
                        {errors.name && (
                          <span className="text-danger">
                            {errors.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </Row>
                  </div>
                  <Col md={6}>
                  <div className="main-form-section my-3">
                    <Form.Group>
                      <div className="text-center">
                        <Form.Label>Sort Order</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="number"
                          name="name"
                          placeholder="Sort Order"
                          className={classNames("", {
                            "is-invalid": errors?.sort_order,
                          })}
                          {...register("sort_order", {
                            required: "sort_order is required",
                          })}
                        />
                      </InputGroup>
                      {errors.sort_order && (
                        <span className="text-danger">{errors.sort_order.message}</span>
                      )}
                    </Form.Group>
                  </div>
                </Col>

                  <div className="main-form-section my-3">
                    <Row className="justify-content-start">
                      <Form.Label className="text-left">Image</Form.Label>

                      <Form.Group>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.image,
                          })}
                          type="file"
                          {...register("image", {
                            validate: async (value) => {
                              if (typeof value !== "string") {
                                const fileTypes = ["jpg", "png", "jpeg"];
                                const fileType = value[0].name?.split(".")[1];
                                if (!fileTypes.includes(fileType)) {
                                  return `please upload a valid file format. (${fileTypes})`;
                                }
                                const sizes = await getDimension(value[0]);
                                if (sizes.width !== 1050 && sizes.height !== 1050) {
                                  return "Image width and height must be 1050  px and 1050  px";
                                }
                                const fileSize = Math.round(value[0].size / 1024);
                                if (fileSize > 500) {
                                  return "file size must be lower than 500kb";
                                }
                              }
                            },
                          })}
                          accept=".jpg, .jpeg, .png"
                        />
                      </Form.Group>
                      <span className="text-danger" >Image width and height must be 1050  px and 1050  px</span>   
                      {/* {errors.image && (
                        <span className="text-danger">
                          {errors.image.message}
                        </span>
                      )} */}
                    </Row>
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="main-form-section my-3">
                    <Form.Label>Image Preview</Form.Label>

                    {typeof getValues("image") == "string" ? (
                      <div className="image-preview-container">
                        <img
                          src={IMG_URL + getValues("image")}
                          alt="Preview"
                          className="image-preview"
                          style={{ width: "120px", height: "100px" }}
                        />
                      </div>
                    ) : (
                      imageFile &&
                      imageFile?.length > 0 && (
                        <div className="image-preview-container">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFile[0])}
                            alt="Preview"
                            className="image-preview"
                            style={{ width: "120px", height: "100px" }}
                          />
                        </div>
                      )
                    )}
                  </div>
                </Col>

                <Row className="mt-5 pb-3">
                  <div className="d-flex justify-content-center">
                    <Link>
                      <CancelButton
                        name={"cancel"}
                        handleClose={props.handleClose}
                      />
                    </Link>

                    <SaveButton
                      name={"save"}
                      handleSubmit={handleSubmit(onSubmit)}
                    />
                  </div>
                </Row>
              </Row>
            </Form>
          </Modal.Body>
        </Modal>

        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </>
    );
  };

  export default EditOffCanvance;
